import { Star, Quote } from "lucide-react";

export default function TestimonialCard({ t }) {
  const initials = t.name.split(" ").map((n) => n[0]).slice(0, 2).join("");
  return (
    <div
      data-testid={`testimonial-${t.id}`}
      className="bg-white border border-slate-200 rounded-3xl p-6 hover:shadow-lg transition-shadow relative"
    >
      <Quote className="absolute top-5 right-5 w-8 h-8 text-teal-100" />
      <div className="flex items-center gap-3 mb-4">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
          style={{ background: t.avatar_color || "#0F766E" }}
        >
          {initials}
        </div>
        <div>
          <div className="font-semibold text-slate-900 text-sm">{t.name}</div>
          <div className="text-xs text-slate-500">{t.location} · {t.date}</div>
        </div>
      </div>
      <div className="flex gap-0.5 mb-3">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
        ))}
      </div>
      <p className="text-sm text-slate-600 leading-relaxed">{t.comment}</p>
      {t.service && (
        <div className="mt-4 pt-4 border-t border-slate-100">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-teal-50 text-teal-700 text-xs font-medium">
            {t.service}
          </span>
        </div>
      )}
    </div>
  );
}
